import React from 'react';
import { t } from 'ttag';


class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renderFooter: false
    };
  }

  componentDidMount() {
    this.setState({
      renderFooter: !window.location.pathname.startsWith('/jegy/client'),
      //footerInverseValue: window.getComputedStyle(document.documentElement).getPropertyValue('--color-font-general')
      

    }, () => {
    if(!this.state.renderHeader) {
      // document.body.style.paddingTop = "0px";
      }
    });
  }

  
 getCorrectTextColor = (hex) => {
  /*
  From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

  Color brightness is determined by the following formula:
  ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

  I know this could be more compact, but I think this is easier to read/explain.

  */

  let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

  function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
  function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
  function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
  function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

  let hRed = hexToR(hex);
  let hGreen = hexToG(hex);
  let hBlue = hexToB(hex);

  let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
  if ((cBrightness > threshold) || (hex === '#') || (hex === '#null')) { return '#000000'; } return '#ffffff';
}

  render() {
    return (
      this.state.renderFooter ? (
      <div className="footer footer--dark lightf-bg" id="sticky-footer" style={{ padding: '20px 0' }}>
        <div className="container">
          <div className="footer__inner">
            <img
              src={process.env.PUBLIC_URL + '/img/zszam_fekete.svg'}
              style={{ height: 90, paddingRight: 20, marginBottom: 25, marginTop: -20, minWidth: '25%' }}
              alt="logo"
              className="footer-logo-dark"
            />
            <img
              src={process.env.PUBLIC_URL + '/img/zszam_feher.svg'}
              style={{ height: 90, paddingRight: 20, marginBottom: 25, marginTop: -20, minWidth: '25%' }}
              alt="logo"
              className="footer-logo-light"
            />
            {/*<a href="https://zszportal.zalaszam.hu/" className="footer__textLogo">Zalaszám Informatika kft.</a>*/}
            <div className="footer__data">
              <div className="footer__data__item">
                <div className="footer__row">
                  <a href="https://zszportal.zalaszam.hu" className="footer__link">Copyright 2019 - © Zalaszám Informatika Kft.</a>
                </div>
                <div className="footer__row">
                  <a href="mailto:organw@zalaszam.hu" className="footer__link">organw@zalaszam.hu</a>
                </div>
              </div>
              <div className="footer__data__item">
                {/* Később kell visszarakni, amikor ki lett alakítva a statikus oldal, vagy más megoldás  */}
                {/* <div className="footer__row"><Link to="/jegy/aszf" className="footer__link">{ t`ÁSZF` }</Link>
                </div>
                <div className="footer__row"><Link to="/jegy/adatvedelmi" className="footer__link">{ t`Adatvédelmi és jogi nyilatkozat` }</Link>
                </div> */}
                <div className="footer__row"><a href="https://zszportal.zalaszam.hu/kapcsolat" className="footer__link">{ t`Kapcsolat` }</a>
                </div>
              </div>
              <div className="footer__data__item">
                <div className="footer__row">
                  <a href="https://www.facebook.com/zalaszam" className="footer__link">Facebook</a>
                </div>
                <div className="footer__row">
                  <a href="https://www.linkedin.com/company/zalaszám-it-consulting/about/" className="footer__link">LinkedIn</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ) : null
    );
  };
};

export default Footer;